module.exports = __webpack_public_path__ + "static/media/rufaida.4c7ca92d.pdf";